import { WorkflowTriggerTypes } from 'src/app/models/RestApiCaller/Enums/workflow-trigger-types';
import { BaseTriggerData } from './base-trigger-data';

/**
 * Représente les données d'un trigger 'Mise à jour d'attribut'..
 */
export class AttributeChangedTriggerData extends BaseTriggerData {
    /**
     * Id de l'attribut à mettre à jour.
     */
    public attributeId: number;

    /**
     * valeur indiquant si le trigger est émis quelque soit la valeur saisie.
     */
    public isTriggeredForAnyValue: boolean;

    /**
     * valeur de l'attribut à mettre à jour.
     */
    public value: string;

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowTriggerTypes.AttributeChanged);
    }

    /**
     * Retourne une copie d'une instance de AttributeChangedTriggerData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: AttributeChangedTriggerData) {
        if (!!other) {
            const instance = new AttributeChangedTriggerData();
            instance.attributeId = other.attributeId;
            instance.isTriggeredForAnyValue = other.isTriggeredForAnyValue;
            instance.value = other.value;
            instance.type = other.type;

            return instance;
        } else {
            return null;
        }
    }
}
